import React, {useState} from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion, useScroll } from 'framer-motion';
import { Link, useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';

import informacionToldos from '../data/todosLosProductos/informacionToldos';
import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import styled from 'styled-components';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import ModalImagenExpandida from '../componentes/ModalImagenExpandida';
import WhatsAppContact from '../componentes/WhastsAppContact';
import Footer from '../componentes/Footer';

const PaginaToldos = () => {
    const navigate = useNavigate();
    const [imagenExpandida, setImagenExpandida] = useState(null);
    return ( 
        <>
        <Helmet>
            <title>Toldos para Exteriores | Hi Blinds</title>
            <meta name="description" content="Toldos funcionales para exteriores. Protección solar y diseño elegante para terrazas, patios y más." />
            <meta property="og:title" content="Toldos para Exteriores | Hi Blinds" />
            <meta property="og:description" content="Protege tus espacios al aire libre con estilo y calidad. Toldos retráctiles, palillería y más." />
            <meta property="og:url" content="https://hiblindsmx.com/toldos" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <h1>Toldos</h1>
                <ContainerProductos toldos>
                    {informacionToldos.map((producto, index) =>  {
                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            key={producto.id} productoToldo
                            onClick={() => {
                                navigate(`/toldos/${producto.slug}`);
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setImagenExpandida(producto.images[0]);
                                  }}
                                style={{cursor: 'pointer'}}
                                 />
                                <h4>{producto.nombre}</h4>
                                <b> {producto.sistema}</b>
                                <Link to={`/toldos/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                               
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                <WhatsAppContact 
                    phoneNumber="524491984191" 
                    defaultMessage="Quiero saber sobre otros modelos de toldos" 
                    />
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡Revisa nuestras telas para cortina!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            <ModalImagenExpandida
                imagen={imagenExpandida}
                onClose={() => setImagenExpandida(null)}
              />
        </>
     );
}

export default PaginaToldos;